import translate from '@/utils/translate';
import {
  ContentSubmissionAnalysisStatus,
  CONTENT_SUBMISSION_ANALYSIS_STATUS,
  CONTENT_SUBMISSION_KIND,
  CONTENT_SUBMISSION_STATUS,
} from '@/types/contentSubmission';

type Params = {
  isAdmin: boolean;
  isLatestVersionSelected: boolean;
  analysisStatus?: ContentSubmissionAnalysisStatus | null;
  isCampaignActive: boolean;
  kind: string;
  aasmState: string;
};

type AnalysisButtonState =
  | {
      show: true;
      label: string;
      disabled: boolean;
      isViewAction: boolean;
    }
  | {show: false};

const SUPPORTS_AI_ANALYSIS_STATES = [
  CONTENT_SUBMISSION_STATUS.PENDING,
  CONTENT_SUBMISSION_STATUS.REJECTED,
  CONTENT_SUBMISSION_STATUS.ARCHIVED,
];

export default function getContentSubmissionAnalysisButtonState(
  params: Params
): AnalysisButtonState {
  const {
    isAdmin,
    isLatestVersionSelected,
    analysisStatus,
    isCampaignActive,
    kind,
    aasmState,
  } = params;

  if (!isAdmin) {
    return {show: false};
  }

  const isAnalysisCompleted =
    analysisStatus === CONTENT_SUBMISSION_ANALYSIS_STATUS.COMPLETED;
  const isAnalysisProcessing =
    analysisStatus === CONTENT_SUBMISSION_ANALYSIS_STATUS.PROCESSING;

  // A completed analysis is always viewable regardless of campaign state or aasmState
  if (isAnalysisCompleted) {
    return {
      show: true,
      label: translate('View AI Analysis'),
      disabled: false,
      isViewAction: true,
    };
  }

  const supportsAiAnalysis = (
    SUPPORTS_AI_ANALYSIS_STATES as readonly string[]
  ).includes(aasmState);

  if (
    !isCampaignActive ||
    kind !== CONTENT_SUBMISSION_KIND.VIDEO ||
    !supportsAiAnalysis
  ) {
    return {show: false};
  }

  // For non-latest versions, only show if there is an active analysis to display
  if (!isLatestVersionSelected && !isAnalysisProcessing) {
    return {show: false};
  }

  if (isAnalysisProcessing) {
    return {
      show: true,
      label: translate('Processing AI analysis'),
      disabled: true,
      isViewAction: false,
    };
  }

  return {
    show: true,
    label: translate('Run AI Analysis'),
    disabled: false,
    isViewAction: false,
  };
}
